export default __webpack_public_path__ + "static/media/Email- Blackmail.693d4b0e.png";